var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "926.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 926.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4590 12790 c-504 -70 -1061 -319 -1550 -694 -180 -137 -298 -243 -500 -445 -205 -205 -343 -365 -514 -591 -809 -1074 -1427 -2586 -1821 -4455 -397 -1880 -213 -3379 554 -4523 644 -962 1746 -1656 3111 -1960 415 -93 737 -131 945 -113 444 40 933 150 1360 308 677 251 1220 590 1686 1053 235 234 352 373 521 620 794 1159 1050 2750 762 4740 -94 651 -444 1797 -817 2675 -547 1291 -1251 2277 -2015 2823 -359 258 -747 434 -1126 512 -224 47 -470 67 -596 50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.6e8adf433c3598289ac47fce77be939e.svg";
export { ForwardRef as ReactComponent };